export default __webpack_public_path__ + "7941cdd0a9153dc7ef77c786d5dadd4a.png";